import React, {Component} from 'react';
import Application from "../components/application/application";
import ApplicationConfirm from "../components/application-confirm/application-confirm";
import Uen from "../components/uen/uen";

const ApplicationPage = (props) => {
    return (
        <React.Fragment>
            {
                !props.match.params.section && <Application />
                ||
                props.match.params.section === 'uen' && <Uen />
                ||
                props.match.params.section === 'confirm' && <ApplicationConfirm />
            }
        </React.Fragment>
    )
}

export default ApplicationPage;
